export const HeaderCta = {
	'link': '/coupons/',
	'copy': 'Coupons',
};
